import React from 'react';
import { Typography } from 'antd';
import type { DispatchOrchestration } from './dispatchOrchestration';

const { Text } = Typography;

type Props = {
  orchestration: DispatchOrchestration;
  onFocusIncident?: (incidentId: number) => void;
};

export const DispatchAttentionPanel: React.FC<Props> = ({
  orchestration,
  onFocusIncident
}) => {
  const { attentionItems } = orchestration;
  const critical = attentionItems.filter((i) => i.priority === 'critical' || i.priority === 'high');

  if (critical.length === 0) return null;

  return (
    <section className="execution-workspace__attention">
      <div className="execution-workspace__section-title">Требует внимания</div>
      {critical.map((item) => (
        <div
          key={item.id}
          className={`execution-workspace__attention-item execution-workspace__attention-item--${item.priority}`}
          role={item.relatedIncidentId != null ? 'button' : undefined}
          tabIndex={item.relatedIncidentId != null ? 0 : undefined}
          onClick={() => {
            if (item.relatedIncidentId != null) onFocusIncident?.(item.relatedIncidentId);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && item.relatedIncidentId != null) {
              onFocusIncident?.(item.relatedIncidentId);
            }
          }}
        >
          <span>{item.icon}</span>
          <div>
            <Text strong style={{ fontSize: 12 }}>
              {item.title}
            </Text>
            {item.detail ? (
              <div className="execution-workspace__muted" style={{ fontSize: 11 }}>
                {item.detail}
              </div>
            ) : null}
          </div>
        </div>
      ))}
    </section>
  );
};

export default DispatchAttentionPanel;
